import React from 'react';
import EcoImg from 'eco-design/base/eco-img';
import EcoSection from 'eco-design/base/eco-section';
import EcoSpace from 'eco-design/base/eco-space';
import styles from './index.module.scss';
import VideoAnimation from './VideoAnimation';
import getLocal from '@/app/utils/getLocal';
import SectionCardEngineer from './SectionCardEngineer';
import { useLang } from '@/app/utils/useLang';

const Engineering: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('theProduct.SectionCardEngineer');
    return (
        <section className={`${styles.Engineering} GtmModuleData-section`} data-section-id="Engineering" data-section-title={t('section_title_1')}>
            {/* {['us', 'ca'].includes(locale) && <SmartLoad pageType="ac" />} */}
            {/*  */}
            <EcoSpace bgColor="#fff" hPad="100px" />
            <SectionCardEngineer />
        </section>
    );
};

export default Engineering;
